<template>
  <div>
    <v-app-bar app flat :style="style">
      <v-spacer></v-spacer>
      <v-btn
        text
        color="primary"
        :to="{ name: 'BusinessRegistration' }"
        v-if="businessRegisterEnabled"
        >Business Sign up</v-btn
      >

      <v-btn
        color="primary"
        exact
        text
        :to="{ name: 'Registration' }"
        v-if="userRegisterEnabled"
        class="mr-4"
        >Sign Up</v-btn
      >
      <v-btn color="primary" outlined :to="{ name: 'SignIn' }">Sign In</v-btn>
    </v-app-bar>

    <v-row align="stretch" justify="center" class="py-0">
      <v-col v-if="test1" cols="12" md="4" class="hidden-md-and-down">
        <v-img :src="test1" contain height="200" />
      </v-col>

      <v-col
        cols="12"
        md="4"
        :class="{ 'py-0': $vuetify.breakpoint.smAndDown }"
      >
        <v-img :src="logo" contain height="200" />
      </v-col>

      <v-col v-if="test2" cols="12" md="4" class="hidden-md-and-down">
        <v-img :src="test2" contain height="200" />
      </v-col>
    </v-row>
    <v-row align="stretch" justify="center" class="py-0">
      <v-col cols="12" md="6">
        <div :style="companyStyle" v-if="displayWelcomePageText">
          {{ companyWelcomePageText }}
        </div>
      </v-col>
    </v-row>

    <v-row
      align="stretch"
      justify="center"
      class="pt-6"
      style="margin-bottom: 40px"
    >
      <v-col
        cols="12"
        :md="allowAnonUsers ? 6 : 12"
        v-if="userRegisterEnabled"
        class="align-content-center"
      >
        <v-card flat class="mx-auto" max-width="400">
          <div
            style="
              height: 100%;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <InlineSvg
              height="200px"
              class="white--text align-end ma-4"
              src="img/undraw/profile.svg"
            ></InlineSvg>
          </div>

          <v-card-title class="pb-0"> Open Your Account! </v-card-title>

          <v-card-text class="text--secondary">
            <div>
              Sign up now and get start ordering, our account holders have
              access to features which make ordering online easy such as
              favourite products, template orders and recreating old orders if
              you want the same items again.
            </div>
          </v-card-text>

          <v-card-actions class="px-4">
            <v-spacer />
            <v-btn
              color="primary"
              :to="{ name: 'Registration' }"
              v-if="userRegisterEnabled"
              ><div class="px-6">
                <b>Sign Up Now</b>
              </div>
            </v-btn>
          </v-card-actions>

          <div class="px-4 mt-4 body-1 text--secondary">
            Already have an account?
          </div>

          <v-card-actions class="px-4">
            <br />
            <v-btn
              color="blue darken-2"
              class="pa-0"
              text
              :to="{ name: 'SignIn' }"
              >Click Here to Sign In
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        v-if="allowAnonUsers"
        cols="12"
        md="6"
        :class="{ 'py-0': $vuetify.breakpoint.smAndDown }"
        style="padding-bottom: 2rem"
      >
        <div class="align-content-center">
          <v-card flat class="mx-auto" max-width="400">
            <div
              style="
                height: 100%;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <InlineSvg
                height="200px"
                class="white--text align-end ma-4"
                src="img/undraw/add_to_cart.svg"
              />
            </div>

            <v-card-title class="pb-0">
              Want to have a look first?
            </v-card-title>

            <v-card-text class="text--secondary">
              <div>
                If you want to see what we have available before signing up then
                just click below and have a browse! Just start adding items to
                your basket then just sign up before checking out.
              </div>
            </v-card-text>

            <v-card-actions class="px-4">
              <v-spacer />
              <AnonSignIn />
            </v-card-actions>
          </v-card>
        </div>

        <!-- <div v-else>
          <h2 class="mb-2">Want to have a look first?</h2>
          <div class="body-1 text--secondary">
            If you're not sure if you want to sign up straight away you can have
            a look at what products we have on sale. If you like what you see
            just sign up and start ordering!
          </div>
          <v-btn
            color="blue darken-2"
            class="mt-2"
            block
            x-large
            text
            @click="signInGuest()"
            :loading="signingIn"
          >
            Start Browsing <v-icon right>chevron_right</v-icon>
          </v-btn>
        </div> -->
      </v-col>
    </v-row>

    <v-row
      align="start"
      justify="center"
      class="pt-8"
      style="background-color: var(--v-primary-darken1) !important"
    >
      <v-col cols="12" md="8" style="margin-top: -80px; margin-bottom: -80px">
        <PostcodeDeliveryRequest @browse-store="signInGuest" />
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="space-between"
      style="margin-top: 80px"
      :class="{
        desktopPaddingTop: $vuetify.breakpoint.mdAndUp,
        desktopPaddingBottom: $vuetify.breakpoint.mdAndUp,
      }"
    >
      <v-col cols="12" md="6" class="mb-4">
        <h2 class="mb-2">Easy to Use</h2>
        <div class="body-1 text--secondary">
          Our ordering process is simple, just sign in, select what date you'd
          like us to deliver on and start adding items to your basket.
        </div>
      </v-col>
      <v-col cols="12" md="4" class="mb-4">
        <InlineSvg src="img/undraw/online_groceries.svg"></InlineSvg>
      </v-col>
    </v-row>

    <v-row
      v-if="cncEnabled"
      align="center"
      justify="space-between"
      style="background: var(--v-background_off-base)"
      :class="{
        'flex-column-reverse': $vuetify.breakpoint.smAndDown,
        desktopPaddingTop: $vuetify.breakpoint.mdAndUp,
        desktopPaddingBottom: $vuetify.breakpoint.mdAndUp,
      }"
    >
      <v-col cols="12" md="4" class="mb-4">
        <InlineSvg src="img/undraw/collect.svg"></InlineSvg>
      </v-col>
      <v-col cols="12" md="6" class="mb-4">
        <h2 class="mb-2">Choose to Click & Collect</h2>
        <div class="body-1">
          If you'd rather collect your order we have a click & collect service
          available, to use it simply switch to Click & Collect when creating
          your order.
        </div>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="space-between"
      :class="{
        'flex-row-reverse': !$vuetify.breakpoint.smAndDown && !cncEnabled,
        desktopPaddingTop: $vuetify.breakpoint.mdAndUp,
        desktopPaddingBottom: $vuetify.breakpoint.mdAndUp,
      }"
    >
      <v-col cols="12" md="6" :class="{ 'pb-16': $vuetify.breakpoint.mdAndUp }">
        <h2 class="mb-2">Pay for your orders Online</h2>
        <div class="body-1 text--secondary">
          We use Stripe as our online payment solution for quick and secure
          payments. Stripe accepts all major debit and credit cards.
        </div>
      </v-col>

      <v-col cols="12" md="4">
        <InlineSvg src="img/undraw/stripe.svg"></InlineSvg>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import PostcodeDeliveryRequest from "./PostcodeDeliveryRequest.vue";

import AnonSignIn from "@/components/auth/anon/SignIn.vue";

export default {
  components: {
    PostcodeDeliveryRequest,
    AnonSignIn,
  },

  data() {
    return {
      companyName: process.env.VUE_APP_COMPANY_NAME,
      showSignInGuest: true,
      signingIn: false,
      // allowAnonUsers: true,
    };
  },

  methods: {
    ...mapActions([
      "authUser",
      "setGuestUser",
      "getCustomer",
      "setGuestTrolly",
      "setSnackbar",
    ]),

    async signInGuest() {
      this.signingIn = true;

      let payload = {
        identity: "nws9987",
        email_addr: "demo@nationwilcox.co.uk",
        password: "pass",
      };

      let response = await this.authUser(payload);

      console.log("Response");
      console.log(response);

      if (response.success) {
        this.setGuestUser(true);

        let customerResponse = await this.getCustomer();
        console.log("-- Customer Response");
        console.log(customerResponse);

        //
        if (customerResponse.success) {
          if (customerResponse.allAvailableDays.length > 0) {
            //Use the last available date as our order date
            let payload = {
              trolly: [],
            };

            let guestTrolly = {
              id: 0,
              trolly_items: {},
              order_date:
                customerResponse.allAvailableDays[
                  customerResponse.allAvailableDays.length - 1
                ],
            };

            payload.trolly.push(guestTrolly);

            console.log("-- Setting Guest Trolly");
            console.log(payload);

            await this.setGuestTrolly(payload);
            this.$router.push({ name: "OrdersSearch" });
          } else {
            //No Days available for the guest user to order on
            this.setSnackbar({
              color: "error",
              text: "There are currently no valid order days enabled for this customer",
            });
          }
        } else {
          //get-customer failed
          this.setSnackbar({
            color: "error",
            text: "Error retrieving customer details",
          });
        }
      } else {
        //auth-user failed
        this.setSnackbar({
          color: "error",
          text: "Unable to sign in as guest user, it may not be configured correctly",
        });
      }

      this.signingIn = false;
    },

    svgLoaded(event) {
      console.log("-- Loaded");
      console.log(event);
    },

    svgUnloaded(event) {
      console.log("-- Loaded");
      console.log(event);
    },

    svgLoadError(event) {
      console.log("-- Loaded");
      console.log(event);
    },
  },

  computed: {
    ...mapGetters([
      "isCashUserRegistrationEnabled",
      "isBusinessRegistrationEnabled",
    ]),

    allowAnonUsers() {
      return this.$store.getters.retrieveAllowAnonUsers;
    },

    userRegisterEnabled() {
      return this.isCashUserRegistrationEnabled;
    },

    businessRegisterEnabled() {
      return this.isBusinessRegistrationEnabled;
    },

    cncEnabled() {
      return this.$store.getters.retrieveCncOrdersEnabled;
    },

    logo() {
      return require(process.env.VUE_APP_LOGO_MAIN);
    },

    test1() {
      return this.$store.getters.retrieveCompanyWelcomeImage1;
    },

    test2() {
      return this.$store.getters.retrieveCompanyWelcomeImage2;
    },

    logoPath() {
      return process.env.VUE_APP_LOGO_MAIN;
    },

    companyWelcomePageText() {
      return this.$store.getters.retrieveCompanyWelcomePageText;
    },
    displayWelcomePageText() {
      if (this.$store.getters.retrieveCompanyWelcomePageText == "no-message") {
        return false;
      }
      return true;
    },

    companyStyle() {
      const Style = {
        color: this.$vuetify.theme.themes[this.theme].primary,
        "text-align": "center",
        "font-size": "3rem !important",
        "font-weight": 400,
        // "line-height": "3.125rem",
        "letter-spacing": "normal !important",
        "font-family": "Roboto, sans-serif !important",
      };

      console.log("-- Checking Style");
      console.log(this.$store.getters.retrieveAllConfigs);
      console.log(
        this.$store.getters.retrieveAllConfigs
          .company_welcome_page_text_font_size
      );

      if (
        this.$store.getters.retrieveAllConfigs
          .company_welcome_page_text_font_size
      ) {
        Style["font-size"] =
          this.$store.getters.retrieveAllConfigs
            .company_welcome_page_text_font_size + "px";
      }

      return Style;
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },

    style() {
      const Style = {
        background: this.$vuetify.theme.themes[this.theme].background,
        // background: "#ffffff00",
        color: this.$vuetify.theme.themes[this.theme].color,
        "border-bottom": "1px solid var(--v-menu_border_color-base)",
      };

      return Style;
    },

    borderStyle() {
      const Style = {
        "border-top":
          " 6px solid" + this.$vuetify.theme.themes[this.theme].primary,
      };

      return Style;
    },
  },
};
</script>

<style lang="css" scoped>
.off_text {
  color: rgba(245, 245, 245, 0.95);
}

.desktopPaddingTop {
  padding-top: 2rem !important;
}

.desktopPaddingBottom {
  padding-bottom: 2rem !important;
}
</style>